import type { Article } from "./types";

export const articles: Article[] = [
  {
    id: "art-001",
    slug: "top-actor-cheating-scandal-exposed",
    title: "顶流男星出轨实锤曝光！酒店监控画面流出， wife 片场崩溃大哭",
    excerpt: "某一线男星被曝与神秘女子多次出入酒店，现场监控画面清晰可辨。其妻子得知消息后正在剧组拍摄现场情绪崩溃，工作人员紧急疏散...",
    content: `近日，某一线男星被狗仔拍到与神秘女子多次出入同一家五星级酒店，时间跨度长达三个月。据知情人士透露，该男星每次出入酒店都会刻意伪装，戴帽子、口罩全副武装，但仍被高清监控画面拍下。

爆料人称，该男星与妻子表面恩爱，实则早已貌合神离。妻子在剧组拍摄现场得知消息后当场崩溃大哭，导演不得不暂停拍摄，整个剧组陷入混乱。

更劲爆的是，据酒店工作人员透露，该神秘女子并非圈内人士，而是某知名企业的女高管，两人疑似在一次商业活动中结识。女高管经常深夜独自前往酒店"等待"，而男星则在工作结束后悄悄前往。

目前该男星团队尚未对此事作出回应，但其社交媒体评论区已经沦陷，大量粉丝表示"塌房"失望。更有粉丝扒出该男星此前在访谈中多次强调"家庭最重要"，如今看来格外讽刺。

值得注意的是，该男星最近正在拍摄一部爱情题材电影，片方或将面临巨大的公关危机。业内知情人士透露，多个代言品牌已经紧急召开内部会议，商讨是否解约事宜。`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20photography%20of%20hotel%20entrance%20at%20night%20with%20flash%20photography%20warm%20street%20lighting%2C%20celebrity%20scandal%20atmosphere%2C%20dark%20moody%20high%20contrast%20editorial%20style%20with%20golden%20warm%20tones&width=800&height=600&seq=article-001&orientation=landscape",
    author: "爆料小能手",
    date: "2026-07-01",
    views: 2847563,
    isHot: true,
    isVideo: true,
    tags: ["出轨", "顶流男星", "酒店监控", "塌房"],
  },
  {
    id: "art-002",
    slug: "internet-celebrity-fake-persona-collapsed",
    title: "千万网红 fake 人设彻底崩塌！学历造假、整容前照片全网疯传",
    excerpt: "坐拥千万粉丝的知名网红被扒出学历造假，所谓的'海龟硕士'竟是购买的假文凭。更劲爆的是其整容前照片被前男友曝光...",
    content: `坐拥千万粉丝的知名美妆博主"小甜心"近日人设彻底崩塌。有网友扒出其自称的"英国硕士学历"实为某东南亚国家购买的假文凭，不仅学校查无此人，连文凭编号都是伪造的。

更令人震惊的是，其"纯天然美女"的人设也遭前男友实锤打脸。前男友在社交媒体上发布了大量其整容前的照片，包括手术预约记录、术后恢复期的肿胀照片等。据前男友透露，小甜心先后进行了双眼皮、隆鼻、削骨、隆胸等多项手术，累计花费超过百万。

而其一直标榜的"白手起家创业故事"也被前合伙人揭穿。前合伙人发文称，小甜心的第一桶金来自父母资助，所谓的"从0到千万"完全是编造的故事。其早期使用的豪宅、豪车均为租借，目的是营造"成功人士"形象。

目前小甜心的多个社交平台账号已被限流，合作品牌纷纷解约。其在直播间内哭着道歉的画面被网友截图疯传，但评论区几乎一边倒的嘲讽声音。有粉丝表示"真情实感追了三年，原来全是假的"。

业内人士分析，这一事件将对整个网红行业造成深远影响，消费者的信任危机可能导致带货行业整体下滑。`,
    category: "网红爆料",
    categorySlug: "influencer-gossip",
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20photoshoot%20setup%20with%20ring%20light%20and%20camera%20equipment%2C%20behind%20the%20scenes%20reveal%20photography%2C%20warm%20amber%20lighting%20with%20dark%20shadows%2C%20documentary%20editorial%20style%20moody%20atmosphere&width=800&height=600&seq=article-002&orientation=landscape",
    author: "八卦追踪站",
    date: "2026-06-30",
    views: 1958321,
    isHot: true,
    tags: ["网红翻车", "人设崩塌", "学历造假", "整容"],
  },
  {
    id: "art-003",
    slug: "variety-show-scripted-fight-exposed",
    title: "热门综艺嘉宾互撕竟是剧本？导演组完整台本泄露，观众被耍了",
    excerpt: "某S级综艺节目被曝嘉宾冲突场景全部按剧本演出，完整导演台本被工作人员泄露，详细标注了每位嘉宾的台词、表情和动作指导...",
    content: `近日，某S级综艺节目被前工作人员爆料存在严重造假行为。泄露的导演台本显示，节目中引发全网热议的"嘉宾互撕"场景全部按照剧本演出，每位嘉宾的台词、表情甚至争吵时的走位都经过精心设计。

据泄露的台本显示，节目组会提前一个月编写"冲突剧本"，安排不同嘉宾之间产生矛盾。台本中甚至详细标注了"此处应有眼泪""此处应有摔门动作"等指导。更有意思的是，嘉宾之间看似即兴的对话，实则在彩排中反复练习过多次。

一位不愿透露姓名的前工作人员称："观众看到的真人秀，90%都是假的。从早餐吃什么到深夜谈心，全都有安排。连宠物出镜都是节目组租借的。"该工作人员还透露，节目组专门聘请了编剧团队负责设计"爆点"，目标是每期制造至少三个全网热搜。

更令人愤怒的是，节目组会故意剪辑嘉宾的言论，制造"断章取义"的效果。一位嘉宾在节目的完整发言被恶意剪辑，导致该嘉宾遭受长达半年的网络暴力。得知真相后，该嘉宾正在考虑起诉节目组。

目前该综艺节目的豆瓣评分已从8.5暴跌至3.2，评论区充斥着观众的愤怒留言。有观众表示"真情实感追了四季，原来小丑竟是我自己"。`,
    category: "综艺热点",
    categorySlug: "variety-shows",
    image: "https://readdy.ai/api/search-image?query=Television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20live%20feed%2C%20behind%20the%20scenes%20documentary%20photography%2C%20warm%20control%20panel%20lights%20with%20dark%20room%20atmosphere%2C%20editorial%20cinematic%20style%20dramatic%20lighting&width=800&height=600&seq=article-003&orientation=landscape",
    author: "综艺内幕君",
    date: "2026-06-29",
    views: 1674523,
    isHot: true,
    isVideo: true,
    tags: ["综艺造假", "剧本", "嘉宾互撕", "剪辑黑幕"],
  },
  {
    id: "art-004",
    slug: "blockbuster-movie-box-office-fake",
    title: "暑期档票房冠军被曝注水！院线内部数据流出，真实票房不足三分之一",
    excerpt: "某号称票房破50亿的暑期档大片被院线工作人员爆料存在严重票房注水行为。内部系统截图显示，大量'幽灵场'在凌晨时段排片...",
    content: `近日，某暑期档票房冠军电影被院线工作人员爆料存在严重票房注水行为。泄露的内部系统截图显示，该电影在多个城市出现大量"幽灵场"——即凌晨2点到6点之间、票价高达300元、上座率却显示100%的特殊场次。

据爆料人称，这些幽灵场的票房约占该片总票房的40%以上。更有院线经理透露，片方会以"包场做活动"的名义要求院线配合排映幽灵场，事后通过其他方式返还费用。这种操作在业内被称为"对敲票房"，已经是公开的秘密。

一位参与过注水操作的院线员工详细描述了流程：片方先支付一笔"宣传费"给院线，院线用这笔钱购买自己的电影票，制造出高票房的假象。这些票不会有人实际观影，放映厅全程空场运行。有时候一部电影在凌晨3点会有20个厅同时"满座"，但现场一个人都没有。

更让人震惊的是，该片的主创团队在庆功宴上公开讨论"如何突破60亿"，并制定了下一阶段的注水计划。与会者的录音被泄露，其中某导演甚至开玩笑说："反正观众只看数字，没人知道真假。"

目前国家电影局已介入调查，多个院线的负责人被约谈。业内专家认为，如果票房注水属实，该片可能面临票房成绩清零、片方被罚款等严重后果。`,
    category: "影视资讯",
    categorySlug: "film-tv-news",
    image: "https://readdy.ai/api/search-image?query=Empty%20movie%20theater%20with%20projector%20beam%20of%20light%20cutting%20through%20darkness%2C%20rows%20of%20red%20velvet%20seats%2C%20dramatic%20cinematic%20atmosphere%20with%20warm%20golden%20light%20and%20deep%20shadows%2C%20editorial%20photography%20style&width=800&height=600&seq=article-004&orientation=landscape",
    author: "影坛揭秘人",
    date: "2026-06-28",
    views: 1432567,
    isHot: true,
    tags: ["票房造假", "幽灵场", "暑期档", "院线黑幕"],
  },
  {
    id: "art-005",
    slug: "female-celebrity-secret-marriage-child",
    title: "知名女星隐婚生子实锤！亲子鉴定报告曝光，孩子父亲竟是圈内大佬",
    excerpt: "一直以单身人设活跃的某知名女星被曝出已隐婚多年并育有一子。亲子鉴定报告被工作人员泄露，孩子父亲的身份更是令人震惊...",
    content: `一直以"独立女性""不婚主义"人设示人的某知名女星近日被爆惊天大瓜。其工作室前助理泄露了一份亲子鉴定报告，报告显示该女星已育有一子，现年4岁。更劲爆的是，孩子的父亲竟是圈内一位以"正人君子"形象著称的资深制片人。

据爆料，该女星与制片人早在八年前就已经秘密结婚，但为了双方的事业发展，一直对外隐瞒婚姻状态。两人平时几乎不同台出现，但会定期在境外秘密会面。孩子出生后一直由女方父母在国外抚养，女方则继续在国内以"单身"身份活跃于娱乐圈。

泄露的资料显示，该女星每年会安排一到两次"海外度假"，实则是去陪伴孩子。而其社交媒体上的"一个人也很好""享受独处"等言论，如今看来格外讽刺。有粉丝翻出其在综艺中表示"从来没有考虑过结婚生子"的发言，质疑其诚信。

制片人的身份更令人震惊。该制片人在圈内以"模范丈夫""顾家好男人"著称，与妻子结婚20年，经常在公开场合秀恩爱。其妻子在得知消息后发表声明表示"需要时间冷静"，暗示婚姻可能出现危机。

目前双方均未对此事作出正面回应，但双方的社交媒体都已设置为"仅关注可评论"。这场风波或将引发娱乐圈新一轮的信任危机。`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Celebrity%20couple%20at%20red%20carpet%20event%20from%20distance%20paparazzi%20style%20photography%2C%20warm%20spotlight%20and%20flash%20photography%20high%20contrast%2C%20glamorous%20atmosphere%20with%20dark%20background%20golden%20warm%20tones%2C%20editorial%20style&width=800&height=600&seq=article-005&orientation=landscape",
    author: "明星侦探社",
    date: "2026-06-27",
    views: 3214567,
    isHot: true,
    isVideo: true,
    tags: ["隐婚", "生子", "圈内大佬", "人设崩塌"],
  },
  {
    id: "art-006",
    slug: "tech-billionaire-affair-scandal",
    title: "科技新贵 CEO 婚外情曝光！秘书爆料三年地下情，聊天记录太劲爆",
    excerpt: "某知名科技公司CEO被前秘书爆料存在长达三年的婚外情。大量露骨聊天记录被公开，涉及内容令人瞠目结舌，股价单日暴跌15%...",
    content: `某市值千亿科技公司的CEO近日被前私人秘书爆出惊天丑闻。该秘书在离职后公开发布了与CEO长达三年的婚外情证据，包括大量露骨聊天记录、酒店开房记录以及亲密照片。

据秘书爆料，这段关系始于一次商务出差。CEO以"工作需要"为由，频繁安排秘书陪同出差，期间多次在酒店发生不正当关系。聊天记录显示，CEO曾许诺秘书"离婚后会娶她"，但三年过去始终未能兑现。

更令人震惊的是，聊天记录中还涉及商业机密泄露。CEO在亲密时刻向秘书透露了公司尚未公开的重大收购计划、财务数据等敏感信息。证券监管机构已表示将介入调查，如属实CEO可能面临内幕交易指控。

该公司股价在丑闻曝光后单日暴跌15%，市值蒸发超过300亿。董事会已召开紧急会议，多位独立董事要求CEO暂时停职接受调查。公司官网上的CEO致辞页面已被临时撤下。

CEO的妻子——一位知名投资人——在社交媒体上发布了一张黑屏图片，配文"谢谢你教会我什么是信任"，疑似间接证实爆料。这场风波正在从桃色新闻向商业丑闻升级，后续影响难以估量。`,
    category: "财经秘闻",
    categorySlug: "finance-gossip",
    image: "https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20exterior%20at%20night%20with%20warm%20interior%20lights%20glowing%20through%20windows%2C%20dramatic%20dark%20sky%20background%20with%20warm%20amber%20tones%2C%20editorial%20architectural%20photography%20cinematic%20atmosphere&width=800&height=600&seq=article-006&orientation=landscape",
    author: "财经爆料局",
    date: "2026-06-26",
    views: 1123789,
    isHot: true,
    tags: ["CEO丑闻", "婚外情", "内幕交易", "股价暴跌"],
  },
  {
    id: "art-007",
    slug: "social-media-scandal-viral-video",
    title: "街拍事件再升级！女主完整身份被扒，过往黑料一波接一波",
    excerpt: "近日引爆全网的街拍牵手门事件持续发酵。涉事女主的完整身份信息被网友扒出，其过往经历、社交账号、感情史全部被曝光...",
    content: `近日引爆全网的"街拍牵手门"事件持续升级。涉事女主的完整身份信息被网友逐层扒出，其社交账号、过往经历、感情史等全部被公开在阳光下。

据网友爆料，该女主并非如最初传闻的"普通职员"，而是有着复杂背景的社交达人。其社交账号上充斥着大量奢侈生活展示，包括名牌包包、豪车、私人飞机等，与其公开的职业收入严重不符。

更有知情人士透露，女主常年活跃于各类高端社交场合，与多位商界人士关系密切。其前男友也跳出来爆料，称女主在恋爱期间就曾"脚踏多条船"，并晒出大量聊天记录作为证据。

随着事件发酵，女主就读的大学也被卷入舆论漩涡。其大学同学爆料称，女主在校期间就因"作风问题"多次被辅导员约谈。毕业后的第一份工作也是因为"特殊关系"获得，入职三个月就升职。

男主方面，其所在公司已宣布将其免职并接受调查。其妻子——一位知名律师——已委托律师团队处理离婚事宜。这场始于街拍的丑闻，正在演变成一场波及多人的社会事件。`,
    category: "社会热点",
    categorySlug: "social-hot",
    image: "https://readdy.ai/api/search-image?query=Busy%20urban%20street%20scene%20with%20pedestrians%20motion%20blur%20warm%20evening%20light%2C%20street%20photography%20style%20with%20dramatic%20cinematic%20atmosphere%2C%20warm%20amber%20and%20orange%20tones%20against%20dark%20shadows%2C%20editorial%20documentary%20style&width=800&height=600&seq=article-007&orientation=landscape",
    author: "社会观察家",
    date: "2026-06-25",
    views: 4567823,
    isHot: true,
    isVideo: true,
    tags: ["街拍门", "身份被扒", "婚外情", "全网热搜"],
  },
  {
    id: "art-008",
    slug: "new-drama-plagiarism-controversy",
    title: "爆款新剧涉嫌抄袭！韩国编剧发函维权，相似度高达80%引热议",
    excerpt: "近期热播的某古装剧被韩国知名编剧指控抄袭。对比分析显示两部作品在情节设定、人物关系、关键桥段上的相似度高达80%...",
    content: `近期在各大平台热播的某古装剧陷入抄袭风波。韩国知名编剧金某通过其代理律师向该剧制片方发出律师函，指控该剧抄袭其2019年创作的剧本《月光下的誓言》。

专业对比分析显示，两部作品在核心设定上惊人相似：都是"失忆公主复仇记"的框架，都安排了"假意接近真动情"的感情线，甚至连关键桥段——如"雨夜骑马追人""毒药换解药""身份揭露时的灯笼场景"——都高度雷同。

韩国编剧金某在社交媒体上发文称："我花了三年打磨的剧本，被他们用三个月就'改编'完了。"她还晒出了时间线证据，显示其剧本在2018年就已经在韩国编剧协会登记备案，远早于该剧的立项时间。

该剧编剧团队在事件爆发后保持沉默，其社交媒体账号设置为"仅粉丝可见"。有业内人士透露，该剧的编剧实为"枪手代写"，真正的创作团队在海外购买了大量剧本进行"本土化改编"。

平台方目前已暂停该剧的推广资源，并表示将等待调查结果。但观众并不买账，评论区充斥着"抄袭可耻""支持维权"的声音。该剧的豆瓣评分也在事件曝光后从7.8暴跌至3.5。`,
    category: "影视资讯",
    categorySlug: "film-tv-news",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20palace%20interior%20set%20with%20red%20lanterns%20and%20warm%20ambient%20lighting%2C%20period%20drama%20filming%20set%20behind%20scenes%20photography%2C%20dramatic%20warm%20golden%20tones%20with%20dark%20shadows%2C%20editorial%20cinematic%20style&width=800&height=600&seq=article-008&orientation=landscape",
    author: "影视深扒组",
    date: "2026-06-24",
    views: 987654,
    tags: ["抄袭", "韩剧维权", "古装剧", "编剧风波"],
  },
  {
    id: "art-009",
    slug: "diva-concert-lip-sync-exposed",
    title: "天后演唱会假唱实锤！音轨对比画面曝光，全场观众被骗两小时",
    excerpt: "某乐坛天后级歌手巡回演唱会被曝全程假唱。技术人员泄露的音轨对比显示，现场演唱与预录音频的波形完全重合...",
    content: `某华语乐坛天后级歌手的巡回演唱会被技术人员爆出全程假唱。泄露的音轨对比视频显示，现场"演唱"的波形与提前录制的音轨波形几乎完全重合，连换气点的位置都一模一样。

据现场技术人员透露，该歌手在演唱会上佩戴了隐藏式耳返，里面播放的并非现场伴奏，而是完整的人声音轨。歌手只需要对口型即可。更夸张的是，有些歌曲甚至使用了多年以前的录音版本，与歌手现在的嗓音状态有明显差异。

有观众表示，自己花了4800元购买的VIP门票，"坐了两个小时听CD"。更有粉丝翻出现场视频，指出多处"演唱"时的嘴型与歌词不同步、高音部分嘴型几乎不动等明显破绽。

歌手的经纪团队在事件爆发后发布声明，称"因身体不适使用了部分垫音"，但拒不承认假唱。然而 leaked 的技术资料显示，垫音比例在某些歌曲中高达100%，即完全没有现场演唱。

文化和旅游部门已介入调查，如假唱属实，主办方可能面临巨额罚款，该歌手后续演出计划也可能被取消。这场风波再次引发了公众对"演唱会真实性"的广泛讨论。`,
    category: "综艺热点",
    categorySlug: "variety-shows",
    image: "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlight%20and%20smoke%20effects%2C%20empty%20microphone%20stand%20center%20stage%2C%20warm%20golden%20stage%20lighting%20with%20dark%20audience%20area%2C%20editorial%20concert%20photography%20cinematic%20atmosphere&width=800&height=600&seq=article-009&orientation=landscape",
    author: "演出爆料王",
    date: "2026-06-23",
    views: 2345678,
    isHot: true,
    isVideo: true,
    tags: ["假唱", "天后", "演唱会", "音轨泄露"],
  },
  {
    id: "art-010",
    slug: "influencer-tax-evasion-investigation",
    title: "头部主播逃税被查！补税金额高达2.3亿，直播行业迎来最强整顿",
    excerpt: "某平台头部带货主播因涉嫌偷逃税款被税务部门立案调查。初步核算的补税金额高达2.3亿元，旗下关联公司也被一并调查...",
    content: `某短视频平台头部带货主播"带货一哥"近日因涉嫌偷逃税款被税务部门立案调查。据知情人士透露，初步核算的补税金额高达2.3亿元，可能创下直播行业个人补税记录。

调查显示，该主播通过设立多家个人独资企业、虚构业务往来、隐瞒真实收入等方式逃避纳税义务。其直播间的"坑位费"和"佣金"收入大部分流入了注册在税收优惠地区的空壳公司，而主播本人只申报了极少部分个人收入。

更令人震惊的是，该主播还涉嫌通过"阴阳合同"逃避税款。对外公开的代言合同中标注的金额远低于实际成交金额，差额部分通过"咨询服务费"等名义转入关联公司。税务稽查人员在其办公室搜出了大量未入账的现金和贵重礼品。

直播行业协会已发布紧急通知，要求所有主播进行自查自纠。多个平台也宣布升级税务合规审查机制。业内专家预计，这一轮整顿可能波及整个直播行业，补税总额可能超过百亿。

该主播的直播间目前已被平台封禁，其个人账号也被设置为"不可见"。这场风波正在从税务问题向商业诚信危机蔓延，其合作的品牌方纷纷宣布解约。`,
    category: "网红爆料",
    categorySlug: "influencer-gossip",
    image: "https://readdy.ai/api/search-image?query=Livestream%20studio%20setup%20with%20multiple%20cameras%20ring%20lights%20and%20product%20displays%2C%20behind%20the%20scenes%20documentary%20photography%2C%20warm%20ambient%20lighting%20with%20dark%20moody%20atmosphere%2C%20editorial%20style%20with%20dramatic%20shadows&width=800&height=600&seq=article-010&orientation=landscape",
    author: "税务爆料台",
    date: "2026-06-22",
    views: 1876543,
    isHot: true,
    tags: ["逃税", "主播", "补税", "直播行业整顿"],
  },
  {
    id: "art-011",
    slug: "young-actor-drug-scandal-arrested",
    title: "当红小生涉毒被抓！警方通报已确认，多部待播剧恐遭下架",
    excerpt: "某95后当红男演员因涉嫌吸毒被警方抓获。北京警方发布情况通报确认该消息，其多部待播影视剧面临下架风险...",
    content: `北京警方今日发布情况通报，确认某95后当红男演员李某因涉嫌吸毒被抓获。通报称，警方根据群众举报在某酒吧将李某抓获，现场查获少量毒品，李某对吸毒行为供认不讳。

李某是近年来迅速蹿红的流量明星，主演的多部网剧播放量破百亿。其在荧幕上一直以"阳光少年"形象示人，拥有大量年轻粉丝。此次涉毒事件堪称"人设彻底崩塌"。

更令人关注的是，李某目前有待播影视剧5部，涉及投资额超过10亿元。根据相关规定，涉毒艺人参演的作品将面临下架或换脸重拍。多家视频平台已宣布将其参演的所有作品暂时下架，待进一步处理方案。

李某的经纪公司发布公告，称已与其解除合约，并"严厉谴责任何违法行为"。但网友并不买账，翻出该公司此前在李某被传"夜店狂欢"时的辟谣声明，质疑其"早就知情"。

此外，李某的多个代言品牌已宣布解约，违约金总额可能超过5000万。其社交媒体账号已被封禁，粉丝超话也被关闭。这场风波再次引发了娱乐圈"德艺双馨"的大讨论。`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Night%20club%20exterior%20with%20neon%20lights%20and%20rain%20wet%20street%20reflections%2C%20documentary%20street%20photography%20style%2C%20moody%20dark%20atmosphere%20with%20warm%20neon%20colors%2C%20editorial%20cinematic%20style%20dramatic%20lighting&width=800&height=600&seq=article-011&orientation=landscape",
    author: "娱乐快报",
    date: "2026-06-21",
    views: 3987654,
    isHot: true,
    isVideo: true,
    tags: ["涉毒", "95后小生", "警方通报", "作品下架"],
  },
  {
    id: "art-012",
    slug: "real-estate-tycoon-mistress-network",
    title: "地产大亨情妇 network 曝光！同时交往12人，每人每月发50万生活费",
    excerpt: "某地产大亨的情妇网络被前助理曝光。详细资料显示其同时与12名女性保持关系，建立了一套完整的管理体系...",
    content: `某知名地产大亨的前助理近日曝光了一份令人震惊的"情妇管理档案"。资料显示，该大亨同时与12名女性保持不正当关系，并建立了一套完整的管理体系。

据档案显示，这12名"女友"被分为三个等级：A级每月生活费50万，要求"随叫随到"；B级每月30万，每周至少见面两次；C级每月15万，不定期约会。所有费用通过一家"文化咨询公司"发放，以"顾问费"名义入账。

更夸张的是，该大亨还建立了一个内部社交软件群组，用于协调各位"女友"的日程安排，避免"撞车"。群组名为"家庭聚会"，内含详细的排班表、喜好记录和禁忌事项清单。

助理透露，该大亨每年在这方面的支出超过2000万，还不包括各类礼物、旅行费用。其位于某度假区的"私人会所"专门用于接待这些"女友"，配备有完整的管家团队和安保系统。

大亨的妻子——某知名慈善家——在得知消息后表示"将通过法律途径维护合法权益"。据悉，两人并未签署婚前协议，如离婚妻子可能分得半数以上财产。这场风波正在向"天价离婚案"方向演变。`,
    category: "财经秘闻",
    categorySlug: "finance-gossip",
    image: "https://readdy.ai/api/search-image?query=Luxury%20villa%20exterior%20at%20night%20with%20warm%20pool%20lights%20and%20palm%20trees%2C%20architectural%20photography%20with%20dramatic%20warm%20golden%20tones%20against%20dark%20night%20sky%2C%20editorial%20lifestyle%20style%20cinematic%20atmosphere&width=800&height=600&seq=article-012&orientation=landscape",
    author: "地产揭秘",
    date: "2026-06-20",
    views: 2654321,
    isHot: true,
    tags: ["地产大亨", "情妇网络", "天价生活费", "离婚风波"],
  },
];
